import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { formatStartTime } from 'lib/util/formatStartTime';
import { ProductShape } from '../../../../lib/util/productShape';
import { LocationList } from '../LocationList/LocationList';

interface Props {
  product: ProductShape;
}

export const DropoffCheckoutTab = ({ product }: Props) => {
  const { t } = useTranslation();

  const [selectedTimeSlotKey, setSelectedTimeSlotKey] = React.useState<string>(
    product.startTimes.length > 0 ? product.startTimes[0].timeSlotKey : ''
  );
  const handleStartTimeChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedTimeSlotKey(event.target.value);

  const showDropoffSection = product.dropoffLocations.length > 0;
  const showCheckoutSection = product.checkoutLocations.length > 0;

  const selectedStartTime = product.startTimes.find(
    (startTime) => startTime.timeSlotKey === selectedTimeSlotKey
  );

  return (
    <div className="c-schedule">
      <label className="c-schedule__select">
        <select name="startTime" value={selectedTimeSlotKey} onChange={handleStartTimeChange}>
          {product.startTimes.map((startTime) => (
            <option key={startTime.timeSlotKey} value={startTime.timeSlotKey}>
              {formatStartTime(startTime)}
            </option>
          ))}
        </select>
      </label>
      {showDropoffSection && (
        <>
          <p className="c-schedule__headline">{t('Dropoff Locations / Times')}</p>
          <LocationList startTime={selectedStartTime} locations={product.dropoffLocations} />
        </>
      )}
      {showCheckoutSection && (
        <>
          <p className="c-schedule__headline">{t('Checkout Times / Locations')}</p>
          <LocationList startTime={selectedStartTime} locations={product.checkoutLocations} />
        </>
      )}
    </div>
  );
};
